import { useState, useEffect } from 'react';
import { Bug } from 'lucide-react';
import BugReportModal from '../BugReportModal';
import styles from './BugReportButton.module.css';

export default function BugReportButton() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Keyboard shortcut: Cmd/Ctrl + Shift + B
  useEffect(() => {
    const handleKeyPress = (e: KeyboardEvent) => {
      if ((e.metaKey || e.ctrlKey) && e.shiftKey && e.key === 'B') {
        e.preventDefault();
        setIsModalOpen(true);
      }
    };

    window.addEventListener('keydown', handleKeyPress);
    return () => window.removeEventListener('keydown', handleKeyPress);
  }, []);

  return (
    <>
      <button
        className={styles.floatingButton}
        onClick={() => setIsModalOpen(true)}
        title="Signaler un bug (Cmd+Shift+B)"
        aria-label="Signaler un bug"
        type="button"
      >
        <Bug size={24} />
      </button>

      <BugReportModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </>
  );
}
